<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-layout wrap>
      <v-flex>
        <AboutUs :about="about" />
      </v-flex>
    </v-layout>
    <v-layout wrap>
      <v-flex>
        <AboutUs2 />
      </v-flex>
    </v-layout>
    <v-layout py-3 wrap>
      <v-flex> </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex>
        <VisionMission :about="about" />
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import Carousal from '../Home/carousal'
import AboutUs from "./aboutUs";
import AboutUs2 from "./aboutUs2";
import VisionMission from "./visionMission";
import axios from "axios";

export default {
  components: {
    AboutUs,
    AboutUs2,
    VisionMission,
  },
  data() {
    return { about: [], appLoading: false };
  },
  mounted: function () {
    this.getAbout();
  },
  methods: {
    getAbout() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/aboutus/view",
      })
        .then((response) => {
          if (response.data.status) {
            this.about = response.data.data;
            this.appLoading = false;
          } else this.appLoading = false;
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
  },
};
</script>